import { z } from 'zod';
import {
  FEATURE_FLAG_OFFER_DRAFTS,
  FEATURE_FLAG_AVAILABILITY_CALENDAR,
  FEATURE_FLAG_MAP_COORDINATE_SEARCH,
  FEATURE_FLAG_MAP_TEXT_SEARCH,
} from '../feature-flags.js';
import { PermissionScopeEntrySchema } from './permissions.js';

export const OFFER_DRAFTS_CAPABILITY = FEATURE_FLAG_OFFER_DRAFTS;
export const AVAILABILITY_CALENDAR_CAPABILITY = FEATURE_FLAG_AVAILABILITY_CALENDAR;
export const MAP_COORDINATE_SEARCH_CAPABILITY = FEATURE_FLAG_MAP_COORDINATE_SEARCH;
export const MAP_TEXT_SEARCH_CAPABILITY = FEATURE_FLAG_MAP_TEXT_SEARCH;

export const MeContextResponseSchema = z
  .object({
    capabilities: z.array(z.string()),
    permissionScopes: z.array(PermissionScopeEntrySchema),
  })
  .strict();
export type MeContextResponse = z.infer<typeof MeContextResponseSchema>;
